import React from 'react'
const SectionTwo: React.FC<any> = () => {
    return (
        <>
            <div className="table-checkout">
                <div className="container-fluid">
                    <h1>Why Choose KwikCheckout Over Others?</h1>
                <table>
                    <tbody>
                        <tr>
                            <th>Value Prop</th>
                            <th className='tblwidth'>Simpl</th>
                            <th className='tblwidth'>Other Players</th>
                            <th>KwikCheckout by GoKwik</th>
                        </tr>
                        <tr>
                            <td>Deepest 100 Million+ D2C shopper network</td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37}/></td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37}/></td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/right.png' width={37}/></td>
                        </tr>
                        <tr>
                            <td>Highest address pre-fill accuracy and fraudulent pin code detection</td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37}/></td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37}/></td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/right.png' width={37}/></td>
                        </tr>
                        <tr>
                            <td>Highest & most customised discount use cases</td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37}/></td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37}/></td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/right.png' width={37}/></td>
                        </tr>
                        <tr>
                            <td>Best-in-class RTO intelligence with risk based COD interventions</td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37}/></td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37}/></td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/right.png' width={37}/></td>
                        </tr>
                        <tr>
                            <td>Industry's First Partial COD Payment</td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37}/></td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37}/></td>
                            <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/right.png' width={37}/></td>
                        </tr>
                        <tr>
                            <td>Payment assurance with ZERO payment failures</td>
                            <td className='tblalign'>80-85%</td>
                            <td className='tblalign'>80-85%</td>
                            <td className='tblalign'>Up to 100%</td>
                        </tr>
                    </tbody>
                </table>

                </div>
            </div>
        </>
    )
}
export default SectionTwo